import React, { useEffect, useState } from "react";
import {
    TextField,
} from "@mui/material";

export default function PullModificationPlateTextField(props) {

    const { disabled, duplicatePlateIds, setPlateName, setSelectionModel, plateName } = props

    const [value, setValue] = useState(plateName ?? '')

    useEffect(() => {
        setPlateName(value)
    }, [value])

    return (
        <TextField
            variant="standard"
            value={value}
            disabled={disabled}
            onKeyDown={(e) => {
                e.stopPropagation()
                if (e.key === 'Escape') {
                    e.target.blur()
                }
                if (e.key === 'Enter') {
                    e.target.blur()
                }
            }}
            onChange={(event) => setValue(event.target.value)}
            onBlur={() => {
                setSelectionModel(prev => prev.filter(plateId => !duplicatePlateIds.includes(plateId)))
            }}
            fullWidth
            sx={{
                input: {
                    color: 'white',
                    fontSize: '13px',
                    padding: '4px 8px'
                },
                '& .MuiInput-underline:before': {
                    borderBottom: disabled ? 'none' : '1px solid rgba(84, 162, 119, 0.4)'
                },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottom: disabled ? 'none' : '1px solid rgba(76, 146, 107, 0.8)'
                },
                '& .MuiInput-underline:after': {
                    borderBottom: disabled ? 'none' : '1px solid rgba(84, 162, 119, 1)'
                },
            }}
        />
    )
}